export default {
    routerName: '标签详情',
    tag: {
        icon: 'ICON',
        name: '标签名',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
    },
};
